// risk-lists.ts — Endpoints listes standard de risques + import/export.
import { req } from './_internals.js';

export const riskListsApi = {
  getRiskLists: () => req('GET', '/risk-lists'),
  createRiskList: (d: unknown) => req('POST', '/risk-lists', d),
  getRiskList: (id: number | string) => req('GET', '/risk-lists/' + id),
  updateRiskList: (id: number | string, d: unknown) => req('PUT', '/risk-lists/' + id, d),
  deleteRiskList: (id: number | string) => req('DELETE', '/risk-lists/' + id),
  getStandardRisks: (id: number | string) => req('GET', '/risk-lists/' + id + '/risks'),
  createStdRisk: (id: number | string, d: unknown) =>
    req('POST', '/risk-lists/' + id + '/risks', d),
  updateStdRisk: (lid: number | string, rid: number | string, d: unknown) =>
    req('PUT', '/risk-lists/' + lid + '/risks/' + rid, d),
  deleteStdRisk: (lid: number | string, rid: number | string) =>
    req('DELETE', '/risk-lists/' + lid + '/risks/' + rid),
  bulkAssignStages: (lid: number | string, d: unknown) =>
    req('PUT', '/risk-lists/' + lid + '/risks/bulk-stages', d),
  importRisks: (id: number | string, formData: FormData) => {
    const BASE = window.API_BASE || '/api/v1';
    return fetch(`${BASE}/risk-lists/${id}/import`, { method: 'POST', body: formData }).then(
      async (r) => {
        if (r.ok) return r.json();
        const e = (await r.json()) as { detail?: string };
        throw new Error(e.detail || 'Erreur import');
      },
    );
  },
  exportRisksUrl: (id: number | string): string => '/api/v1/risk-lists/' + id + '/export',
};
